var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from "react";
import Loader from "@irati/utils/services/apollo/Loading/Loader";
import { Item, List, Wrapper } from "@irati/ui/src/Reactions/styled";
import { TextButton } from "@irati/ui/src/Button";
import { PickerTitle } from "@irati/ui/src/Reactions";
import { COMPANY_VALUE, COMPANY_VALUE_FIRST_CHAR } from "@irati/ui/src/Reactions/constants";
import LoadCompanyValues from "@irati/companyvalues/apollo/query/CompanyValues";
import authentication from "@irati/auth";
var CompanyValuePicker = /** @class */ (function (_super) {
    __extends(CompanyValuePicker, _super);
    function CompanyValuePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addCompanyValueToString = function (companyValue) {
            var _a = _this.props, onSelect = _a.onSelect, stringToReplace = _a.stringToReplace;
            onSelect(__assign({ stringToAppend: "" + COMPANY_VALUE_FIRST_CHAR + companyValue.tag }, stringToReplace));
        };
        return _this;
    }
    CompanyValuePicker.prototype.render = function () {
        var _this = this;
        var stringToReplace = this.props.stringToReplace;
        var tenantId = authentication.userTenant().uuid;
        return (React.createElement(LoadCompanyValues, { variables: { limit: 100, tenantId: tenantId } }, function (res) {
            if (!res.data || !res.data.companyValues) {
                return null;
            }
            var results = res.data.companyValues.results;
            // if the user has no company values set up, then the picker should not show
            if (!res.loading && !results.length) {
                return null;
            }
            var filteredCompanyValues = results.filter(function (result) { return result.tag.includes(stringToReplace.reducedString); });
            var companyValuesToRender = filteredCompanyValues.length > 0 ? filteredCompanyValues : results;
            return (React.createElement(Wrapper, null,
                React.createElement(PickerTitle, { titleValue: stringToReplace.fullString, type: COMPANY_VALUE }),
                React.createElement(List, null,
                    res.loading && React.createElement(Loader, null),
                    !res.loading &&
                        companyValuesToRender.map(function (companyValue) { return (React.createElement(TextButton, { key: companyValue.uuid, onClick: function () { return _this.addCompanyValueToString(companyValue); } },
                            React.createElement(Item, null,
                                COMPANY_VALUE_FIRST_CHAR,
                                companyValue.tag))); }))));
        }));
    };
    return CompanyValuePicker;
}(Component));
export default CompanyValuePicker;
